import PropTypes from "prop-types";
import classNames from "classnames";

const IconExclamation = ({ className, height = "18px", width = "18px" }) => {
    const classes = classNames("iconExclamation", className);
    return (
        <svg
            width={width}
            height={height}
            className={classes}
            viewBox="0 0 18 18"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            focusable="false"
            aria-hidden="true"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-3.000000, -4.000000)">
                    <g transform="translate(4.000000, 3.000000)">
                        <circle cx="8" cy="10" r="8"></circle>
                        <text
                            transform="translate(8.000000, 8.500000) scale(-1, 1) translate(-8.000000, -8.500000) "
                            fontFamily="Radio Canada"
                            fontSize="14"
                            fontWeight="bold"
                            fill="#FFFFFF"
                        >
                            <tspan x="6" y="15">
                                !
                            </tspan>
                        </text>
                    </g>
                </g>
            </g>
        </svg>
    );
};

IconExclamation.propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
};

export default IconExclamation;
